import React from "react";
import SubHero from "../components/SubHero";
import FaqsData from "../components/FaqData";
import FaqItem from "../components/FaqItem";
import "../assets/css/faq.css";

const Faq = () => {
  return (
    <>
      <div className="faq-container">
        <SubHero name="faq" />
        <div className="accordian">
          {FaqsData.map((item, index) => (
            <FaqItem item={item} index={index} key={index}/>
          ))}
        </div>
      </div>
    </>
  );
};

export default Faq;
